import React from "react";

const StickyMenu = ({
  deal,
  basketData,
  restaurantName,
  routeName,
  postalCode,
  delivery,
  preOrder,
  handleToggleDeliveryDetails,
  getSpendAmount,
  handleClickReward,
  handleOpenMenuFilter
}) => (
  <div className="sticky" id="sticky-menu">
    {(deal && deal.delivery && deal.min_spend_amount && (
      <div className="rewards rew1" onClick={handleClickReward}>{`${
        deal.reward_percent
      }% reward when you spend £${getSpendAmount(
        basketData,
        deal.min_spend_amount
      )}`}</div>
    )) || <noscript />}

    <div
      onClick={() => {
        handleToggleDeliveryDetails(true);
      }}
      className="delivery d-flex visible-xs"
    >
      {((routeName || postalCode) && (
        <React.Fragment>
          <icon className="icon icon-location-white" />
          <div>
            <h5>
              {(delivery && "Delivery To") || "Collection >"}{" "}
              {(delivery && (
                <span className="bold">
                  {(delivery && routeName && routeName) ||
                    postalCode ||
                    (preOrder || "ASAP")}
                </span>
              )) || <span>{restaurantName}</span>}
            </h5>
            {(delivery && (
              <p>
                {preOrder || "ASAP"}{" "}
                {(postalCode && `| ${postalCode}`) || `| ${routeName}` || (
                  <noscript />
                )}
              </p>
            )) || <noscript />}
          </div>
        </React.Fragment>
      )) || <noscript />}
    </div>

    <div className="filter d-flex justify-content-between align-items-center visible-xs">
      <h5>MENU</h5>
      <icon onClick={handleOpenMenuFilter} className="icon icon-filter" />
    </div>
  </div>
);

export default StickyMenu;
